import { render } from "./PagamentoRecargaPix.vue?vue&type=template&id=786bbf9b"
import script from "./PagamentoRecargaPix.vue?vue&type=script&lang=js"
export * from "./PagamentoRecargaPix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__